import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { apiEndpoints } from '../endpoints';
import { queryKeys } from '../react-query.config';
import type { paths } from '@bet99-pickem/api-types';

type AdminQuestionsResponse =
  paths['/api/admin/questions']['get']['responses']['200']['content']['application/json'];
export type Question = AdminQuestionsResponse['questions'][number];
export type Option = NonNullable<Question['options']>[number];

interface GetQuestionsParams {
  pickem_id?: number;
}

export const getQuestions = (params?: GetQuestionsParams): Promise<AdminQuestionsResponse> =>
  api.get(apiEndpoints.getQuestions, { params });

export const useGetQuestionsQuery = (params?: GetQuestionsParams) => {
  return useQuery({
    queryKey: queryKeys.questions.list(params),
    queryFn: () => getQuestions(params),
    select: data => data.questions || [],
  });
};
